import Button from "../../Common/Button";
import pdf from "../../../../assets/img/svg/buttons/pdf.svg";

interface PDFProps {
  className?: string;
  filled?: string;
}

const ExportToPDF: React.FC<PDFProps> = ({ className, filled }) => {
  const exportPDF = () => {};

  return (
    <Button
      icon={pdf}
      onClick={exportPDF}
      variant={filled || "filled"}
      className={className || "pdf_button"}
    />
  );
};

export default ExportToPDF;
